document.addEventListener('click', function(event) {
    if (event.target.matches('.new-custom-size-add-to-cart')) {
      let pre_order_product = event.target.dataset.preOrderProduct;
      let final_sale = event.target.dataset.finalSale;
      let selected_size_variant = event.target.dataset.newSizeVariant;
      let formData = '';
      let loader_btn = event.target.closest('.new-custom_size_selector').querySelector('.new-quick-add-loader');
      let all_size_wrap = event.target.closest('.new-custom_size_selector').querySelector('fieldset');
  
      if (pre_order_product === 'preorder-product') {
        formData = {
          'items': [{
            'id': selected_size_variant,
            'quantity': 1,
            'properties': {
              '_PRE ORDER': ' '
            }
          }]
        };
      }else if(final_sale === 'final-sale'){
        formData = {
          'items': [{
            'id': selected_size_variant,
            'quantity': 1,
            'properties': {
              '_FINAL SALE': ' '
            }
          }]
        };
      } else {
        formData = {
          'items': [{
            'id': selected_size_variant,
            'quantity': 1
          }]
        };
      }
      if(all_size_wrap){
        all_size_wrap.style.opacity = '0';
      }
      if(loader_btn){
        loader_btn.style.display = 'flex';
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        let cart_count_div = document.querySelector('.header__desktop .header__cart__status');
        cart_count_div.textContent = parseInt(cart_count_div.textContent) + 1;
        if(all_size_wrap){
          all_size_wrap.style.opacity = '1';
        }
        if(loader_btn){
          loader_btn.style.display = 'none';
        }
      })
      .catch(error => {
        if(all_size_wrap){
          all_size_wrap.style.opacity = '1';
        }
        if(loader_btn){
          loader_btn.style.display = 'none';
        }
        console.error('Error fetching the cart:', error);
      });
    }
  });